module.exports = __webpack_public_path__ + "img/ico_help_green.6319f956.svg";